export type CreditorTemplate = {
  name: string;
  matchAny: string[];            // vendor contains any of these
  defaultExpenseAccountNo: string;
  defaultVatRate: number;        // decimal: 0.081 = 8.1%
};

export const CREDITOR_TEMPLATES: CreditorTemplate[] = [
  { name: "Swisscom", matchAny: ["swisscom"], defaultExpenseAccountNo: "6500", defaultVatRate: 0.081 },
  { name: "Adobe", matchAny: ["adobe"], defaultExpenseAccountNo: "6700", defaultVatRate: 0.081 },
  { name: "Microsoft", matchAny: ["microsoft", "msft"], defaultExpenseAccountNo: "6700", defaultVatRate: 0.081 },
  { name: "Büromaterial", matchAny: ["office", "büro", "papier", "staples"], defaultExpenseAccountNo: "6300", defaultVatRate: 0.081 }
];

export function pickCreditorTemplate(vendor: string): CreditorTemplate | null {
  const v = (vendor || "").toLowerCase();
  if (!v) return null;
  for (const t of CREDITOR_TEMPLATES) {
    if (t.matchAny.some(m => v.includes(m))) return t;
  }
  return null;
}
